import { useRouter } from '@tanstack/react-router';
import { useRegisterBreadcrumbs } from '@/services/breadcrumbs';

export type AppsLeafCrumb = {
  id: string;
  text: string;
  href: string;
};

export function useAppsHrefs(workspaceId: number | 'last') {
  const router = useRouter();

  return {
    settings: router.buildLocation({ to: '/workspaces/$workspaceId/settings', params: { workspaceId } }).href,
    index: router.buildLocation({
      to: '/workspaces/$workspaceId/settings/actions/apps',
      params: { workspaceId },
    }).href,
    create: router.buildLocation({
      to: '/workspaces/$workspaceId/settings/actions/apps/create',
      params: { workspaceId },
    }).href,
    edit: (appId: number) =>
      router.buildLocation({
        to: '/workspaces/$workspaceId/settings/actions/apps/edit/$appId',
        params: { workspaceId, appId: String(appId) },
      }).href,
  };
}

export function useAppsBreadcrumbs(workspaceId: number | 'last', leaf?: AppsLeafCrumb) {
  const hrefs = useAppsHrefs(workspaceId);

  useRegisterBreadcrumbs([
    { id: 'workspace_settings', text: 'Workspace settings', href: hrefs.settings },
    { id: 'workspace_settings_apps', text: 'Mobile apps', href: hrefs.index },
    ...(leaf == null ? [] : [leaf]),
  ]);
}
